import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
interface LocationFiltersProps {
  onClose: () => void;
  onChange: (filters: LocationFilters) => void;
}
interface LocationFilters {
  locationType?: string[];
  tags?: string[];
  lastUsedDateRange?: {
    from: string;
    to: string;
  };
}
const LocationFilters: React.FC<LocationFiltersProps> = ({
  onClose,
  onChange
}) => {
  const [filters, setFilters] = useState<LocationFilters>({
    locationType: [],
    tags: [],
    lastUsedDateRange: {
      from: '',
      to: ''
    }
  });
  const locationTypes = ['Pickup', 'Delivery', 'Both'];
  const commonTags = ['Warehouse', 'Distribution Center', 'Retail', 'Manufacturing', 'High Volume'];
  const toggleLocationType = (type: string) => {
    const updatedTypes = filters.locationType?.includes(type) ? filters.locationType.filter(t => t !== type) : [...(filters.locationType || []), type];
    const updatedFilters = {
      ...filters,
      locationType: updatedTypes
    };
    setFilters(updatedFilters);
    onChange(updatedFilters);
  };
  const toggleTag = (tag: string) => {
    const updatedTags = filters.tags?.includes(tag) ? filters.tags.filter(t => t !== tag) : [...(filters.tags || []), tag];
    const updatedFilters = {
      ...filters,
      tags: updatedTags
    };
    setFilters(updatedFilters);
    onChange(updatedFilters);
  };
  const handleDateChange = (field: 'from' | 'to', value: string) => {
    const updatedFilters = {
      ...filters,
      lastUsedDateRange: {
        ...(filters.lastUsedDateRange || {}),
        [field]: value
      }
    };
    setFilters(updatedFilters);
    onChange(updatedFilters);
  };
  const clearFilters = () => {
    const clearedFilters = {
      locationType: [],
      tags: [],
      lastUsedDateRange: {
        from: '',
        to: ''
      }
    };
    setFilters(clearedFilters);
    onChange(clearedFilters);
  };
  return <div className="mb-6 bg-white p-4 rounded-md shadow-sm" data-id="element-115">
      <div className="flex justify-between items-center mb-4" data-id="element-116">
        <h3 className="text-lg font-medium text-gray-900" data-id="element-117">Filters</h3>
        <button onClick={onClose} className="text-gray-500 hover:text-gray-700" data-id="element-118">
          <XIcon size={20} data-id="element-119" />
        </button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-120">
        {/* Location Type Filter */}
        <div data-id="element-121">
          <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-122">
            Location Type
          </label>
          <div className="space-y-2" data-id="element-123">
            {locationTypes.map(type => <div key={type} className="flex items-center" data-id="element-124">
                <input type="checkbox" id={`type-${type}`} checked={filters.locationType?.includes(type)} onChange={() => toggleLocationType(type)} className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded" data-id="element-125" />
                <label htmlFor={`type-${type}`} className="ml-2 block text-sm text-gray-700" data-id="element-126">
                  {type}
                </label>
              </div>)}
          </div>
        </div>
        {/* Tags Filter */}
        <div data-id="element-127">
          <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-128">
            Tags
          </label>
          <div className="space-y-2" data-id="element-129">
            {commonTags.map(tag => <div key={tag} className="flex items-center" data-id="element-130">
                <input type="checkbox" id={`tag-${tag}`} checked={filters.tags?.includes(tag)} onChange={() => toggleTag(tag)} className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded" data-id="element-131" />
                <label htmlFor={`tag-${tag}`} className="ml-2 block text-sm text-gray-700" data-id="element-132">
                  {tag}
                </label>
              </div>)}
          </div>
        </div>
        {/* Last Used Date Range */}
        <div data-id="element-133">
          <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-134">
            Last Used Date Range
          </label>
          <div className="space-y-3" data-id="element-135">
            <div data-id="element-136">
              <label className="block text-xs text-gray-500 mb-1" data-id="element-137">From</label>
              <input type="date" value={filters.lastUsedDateRange?.from || ''} onChange={e => handleDateChange('from', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500" data-id="element-138" />
            </div>
            <div data-id="element-139">
              <label className="block text-xs text-gray-500 mb-1" data-id="element-140">To</label>
              <input type="date" value={filters.lastUsedDateRange?.to || ''} onChange={e => handleDateChange('to', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500" data-id="element-141" />
            </div>
          </div>
        </div>
      </div>
      <div className="mt-4 flex justify-end" data-id="element-142">
        <button onClick={clearFilters} className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500" data-id="element-143">
          Clear Filters
        </button>
      </div>
    </div>;
};
export default LocationFilters;